import Reveal from './Reveal'

type SectionHeadingProps = {
  eyebrow: string
  title: string
  highlight?: string
  copy?: string
}

export default function SectionHeading({ eyebrow, title, highlight, copy }: SectionHeadingProps) {
  return (
    <Reveal className="section-heading">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h2>{title} {highlight && <span>{highlight}</span>}</h2>
      </div>
      {copy && <p>{copy}</p>}
    </Reveal>
  )
}
